import { jsx as _jsx } from "react/jsx-runtime";
import { HStack, Skeleton, Stack } from '@chakra-ui/react';
import { useOrderItemCardLayout } from '@client/hooks/useOrderItemCardLayout';
import { OrderPreviewCard } from './OrderPreviewCard';
const ORDER_PREVIEW_LIST_MAX_WIDTH = 600;
const SKELETON_ITEM_COUNT = 3;
const COMPACT_SKELETON_HEIGHT = 380;
const STANDARD_SKELETON_HEIGHT = 110;
export const OrderPreviewList = ({ orders, isLoading, linkTo, }) => {
    const { layout, isCompact, cardProps } = useOrderItemCardLayout(isLoading ? SKELETON_ITEM_COUNT : orders.length);
    const content = isLoading
        ? Array.from({ length: SKELETON_ITEM_COUNT }).map((_, i) => (_jsx(Skeleton, { borderRadius: "md", width: cardProps?.width, minW: cardProps?.minW, height: isCompact
                ? COMPACT_SKELETON_HEIGHT
                : STANDARD_SKELETON_HEIGHT }, i)))
        : orders.map((order) => (_jsx(OrderPreviewCard, { order: order, layout: layout, cardProps: cardProps, linkTo: linkTo?.(order) }, order.shortId)));
    return isCompact ? (_jsx(HStack, { gap: 5, m: -5, p: 5, overflowX: "scroll", alignItems: "flex-start", children: content })) : (_jsx(Stack, { width: "100%", maxW: ORDER_PREVIEW_LIST_MAX_WIDTH, gap: 5, children: content }));
};
